import React, { useState } from 'react';
import { Modal, Input } from 'antd';
import { message } from '../services/toastMessage';
import { useTranslation } from 'react-i18next';
import { respondToReview } from '../services/ReviewService';
import { IReview } from '../interfaces/heavyDutyMachinery/IReview';
import { TRANSLATIONS } from '../constants/translations';
import { translate } from '../helpers/translationHelper';

const { TextArea } = Input;

interface RespondToReviewModalProps {
  reviewId: string;
  open: boolean;
  onClose: () => void;
  onSubmitted: (review: IReview) => void;
}

const RespondToReviewModal: React.FC<RespondToReviewModalProps> = ({ reviewId, open, onClose, onSubmitted }) => {
  const { t } = useTranslation();
  const [hostResponse, setHostResponse] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    setHostResponse('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!hostResponse.trim()) {
      message.error(translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_REQUIRED));
      return;
    }
    setSubmitting(true);
    try {
      const review = await respondToReview(reviewId, { hostResponse: hostResponse.trim() });
      message.success(translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_SUCCESS));
      onSubmitted(review);
      handleClose();
    } catch (error: any) {
      message.error(error.message || translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_ERROR));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_MODAL_TITLE)}
      open={open}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_SUBMIT_BUTTON)}
      confirmLoading={submitting}
    >
      <div style={{ marginBottom: 8 }}>{translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_LABEL)}</div>
      <TextArea
        rows={4}
        value={hostResponse}
        onChange={(e) => setHostResponse(e.target.value)}
        placeholder={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND_PLACEHOLDER)}
        maxLength={1000}
      />
    </Modal>
  );
};

export default RespondToReviewModal;
